/**
 * *****************************************************
 * ╔╦╗╔═╗  ╔╗╔╔═╗╔╦╗  ╔╦╗╔═╗╔╦╗╦╔═╗╦ ╦  ╔═╗╔╦╗╔═╗╔╦╗╔═╗┬
 *  ║║║ ║  ║║║║ ║ ║   ║║║║ ║ ║║║╠╣ ╚╦╝  ╚═╗ ║ ╠═╣ ║ ║╣ │
 * ═╩╝╚═╝  ╝╚╝╚═╝ ╩   ╩ ╩╚═╝═╩╝╩╚   ╩   ╚═╝ ╩ ╩ ╩ ╩ ╚═╝o
 * ALWAYS RETURN A COPY
 * *****************************************************
 */

import find from 'lodash.find';
import { DATA_LOADED, SELECT_VEHICLE } from '../actions/constants';
import placeholder from '../../data/placeHolderCopy';

/**
 * [offers description]
 * @param  {[type]} state  =             [] [description]
 * @param  {[type]} action [description]
 * @return {[type]}        [description]
 */
export default function vehicles(state = [], action) {
  switch (action.type) {
    case DATA_LOADED: {
      const blades = (window.offers && window.offers.blades)
        ? window.offers.blades : placeholder.blades;
      const vehiclesCopy = [...action.data.vehicles];
      const vehiclesResult = [];
      blades.forEach((blade) => {
        const isOnState = find(vehiclesCopy, { model: blade.offersModelGroupName });
        if (isOnState) {
          vehiclesResult.push({ model: blade.offersModelGroupName, year: blade.modelYear });
        }
      });

      return vehiclesResult;
    }
    case SELECT_VEHICLE: {
      return state.map((vehicle) => {
        const vehicleCopy = vehicle;

        if (vehicle.model.toLowerCase().replace(' ', '-')
          === action.data.model.toLowerCase().replace(' ', '-')) {
          vehicleCopy.selected = true;
        } else {
          vehicleCopy.selected = false;
        }

        return vehicleCopy;
      });
    }
    default:
      return state;
  }
}
